export const MARKET_TYPES = [
    {display:'New Issue', value:'primary'},
    {display:'Secondary', value:'secondary'}
].map(a => {
    a.label = a.display
    a.value = 'primarySecondary=' + a.value
    return a
})



// WEBPACK FOOTER //
// ./src/twd/values/market-types.js